import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AlertCircle, X } from "lucide-react";
import { useState } from "react";

export default function ExpiredBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  // Show only for signed-in users whose subscription_expires_at has passed.
  if (!user || user.is_subscribed || dismissed) return null;
  const exp = user.subscription_expires_at;
  if (!exp) return null;
  if (new Date(exp) > new Date()) return null;

  const expDate = new Date(exp).toLocaleDateString(undefined, {
    year: "numeric", month: "long", day: "numeric",
  });

  return (
    <div
      data-testid="expired-banner"
      className="fixed top-0 inset-x-0 z-[60] bg-[#E50914] text-white shadow-lg"
    >
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-2.5 flex items-center justify-center gap-3 text-sm flex-wrap">
        <AlertCircle className="w-4 h-4 shrink-0" />
        <span>
          Your YBTV membership expired on <strong>{expDate}</strong>. Renew to keep streaming.
        </span>
        <button
          data-testid="expired-renew-btn"
          onClick={() => navigate("/subscribe")}
          className="rounded-full bg-black/30 hover:bg-black/50 px-4 py-1 text-xs font-semibold tracking-wide uppercase transition"
        >
          Renew — $3.99/mo
        </button>
        <button
          data-testid="expired-dismiss"
          onClick={() => setDismissed(true)}
          className="ml-1 p-1 rounded-full hover:bg-black/30 transition"
          aria-label="Dismiss"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
